// extracted by mini-css-extract-plugin
export default {"viewer":"pdfViewer__viewer-aiNAn","buttonWrapper":"pdfViewer__buttonWrapper-KMgst","button":"pdfViewer__button-evW9B"};